/* React */
import React, { useEffect } from "react";

/* React Router */
import { useLocation } from "react-router";

/* React Redux */
import { useDispatch } from "react-redux";
import { closeMenu } from "src/redux/features/menu/secondary-menu/secondaryMenuSlice";

/* Ionic */
import { menuController } from "@ionic/core/components";
import { IonMenu, IonContent } from "@ionic/react";

/* Components */
import InsightsFilterMenu from "src/components/menus/insights-filter-menu/InsightsFilterMenu";
import AdminDashboardMenu from "src/components/menus/admin-dashboard-menu/AdminDashboardMenu";

/* Constants */
import {
  MenuContentType,
  MenuType,
} from "src/shared/constants/menu/Menu";

/* Stylesheet */
import styles from "./SecondaryMenuWrapper.module.scss";

/* Interfaces */
interface SecondaryMenuWrapperProps {
  menuId: MenuType;
  scssProps?: ScssProps;
}

interface ScssProps {
  padding?: string;
  width?: string;
}

const SeondaryMenuWrapper: React.FC<
  SecondaryMenuWrapperProps
> = ({ menuId, scssProps }) => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    menuController.close(menuId);
  }, [menuId, location.pathname]);

  const renderMenuContent = () => {
    switch (menuId) {
      case MenuType.INSIGHTS_FILTER:
        return <InsightsFilterMenu />;
      case MenuType.ADMIN_DASHBOARD:
        return <AdminDashboardMenu />;
    }
  };

  useEffect(() => {
    menuController.close(menuId);
    dispatch(closeMenu(menuId));
  }, [dispatch, menuId, location.pathname]);

  return (
    <IonMenu
      style={{
        "--width": scssProps?.width,
      }}
      className={styles.secondary_menu_wrapper}
      menuId={menuId}
      contentId={
        menuId === MenuType.INSIGHTS_FILTER
          ? MenuContentType.INSIGHTS_FILTER
          : MenuContentType.ADMIN_DASHBOARD
      }
      side="end"
      type="push"
      onIonWillClose={() => {
        dispatch(closeMenu(menuId));
      }}
    >
      <IonContent className={styles.content_container}>
        <div
          style={{ padding: scssProps?.padding }}
          className={styles.wrapper_container}
        >
          {renderMenuContent()}
        </div>
      </IonContent>
    </IonMenu>
  );
};

export default SeondaryMenuWrapper;
